/**
 * Resolves the `LanguageDropdown` component from the optional
 * fof/discussion-language extension, when it is enabled.
 */
export default function getLanguageDropdown() {
  var _extension$components;
  if (!('fof-discussion-language' in flarum.extensions)) return undefined;
  const extension = flarum.extensions['fof-discussion-language'];
  return (_extension$components = extension.components) == null ? void 0 : _extension$components.LanguageDropdown;
}
flarum.reg.add('fof-blog', 'forum/utils/getLanguageDropdown', getLanguageDropdown);